import Vue from 'vue'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

Vue.component('v-date-picker', DatePicker)

export default {
  components: {
    DatePicker
  }
}
